import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Container } from "../style";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import "./news.css";

const NewsStyled = styled.div`
  padding: 60px 0 20px;
  background-color: #f6f6f6;
`;

const NewsTitle = styled.h2`
  font-size: 28px;
  margin-bottom: 15px;
`;

const NewsDate = styled.div`
  display: flex;
  align-items: center;
  font-size: 16px;
  color: #666;
  margin-bottom: 20px;
  gap: 8px;
`;

const NewsContent = styled.div`
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 20px;
`;

const VideoPlayer = styled.div`
  margin-bottom: 20px;
  iframe {
    width: 100%;
    max-width: 800px;
    height: 450px;
    border: none;
    border-radius: 8px;
  }
`;

const NewsImage = styled.img`
  max-width: 100%;
  height: auto;
  margin-top: 10px;
  border-radius: 8px;
`;

function News() {
  const { t, i18n } = useTranslation();
  const { id } = useParams();
  const [news, setNews] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch(`https://abt.tj/news-backend/api/news?id=${id}`, {
      headers: { "X-API-Key": "2025" },
    })
      .then((res) => {
        if (!res.ok) throw new Error("News not found");
        return res.json();
      })
      .then((data) => setNews(data))
      .catch((err) => setError(err.message));
  }, [id, i18n.language]);

  if (error) {
    return (
      <NewsStyled>
        <Container>
          <h4>{t("news.notFound")}</h4>
        </Container>
      </NewsStyled>
    );
  }

  if (!news) {
    return (
      <NewsStyled>
        <Container>
          <p>{t("news.loading")}</p>
        </Container>
      </NewsStyled>
    );
  }

  const title = news.title[i18n.language];
  const content = news.content ? news.content[i18n.language] : null;
  const images = news.images || [];

  return (
    <NewsStyled>
      <Container>
        <article className="news-item" role="article">
          <NewsDate aria-label={t("news.dateLabel")}>
            <svg
              className="news-item__date-icon"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#718096"
              strokeWidth="2"
            >
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
              <line x1="16" y1="2" x2="16" y2="6" />
              <line x1="8" y1="2" x2="8" y2="6" />
              <line x1="3" y1="10" x2="21" y2="10" />
            </svg>
            {news.date}
          </NewsDate>
          <NewsTitle role="heading" aria-level="2">{title}</NewsTitle>
          {news.content_type === "video" && news.video_url ? (
            <VideoPlayer>
              <iframe
                src={news.video_url}
                title={title}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </VideoPlayer>
          ) : (
            content && (
              <NewsContent className="news-item__content">
                {content.map((text, i) => (
                  <p key={i}>
                    {text}
                    {i < content.length - 1 && <br />}
                  </p>
                ))}
              </NewsContent>
            )
          )}
          {images.length > 0 && (
            <div className="news-item__gallery">
              {images.map((image, index) => (
                <div key={index} className="news-item__image">
                  <NewsImage src={`https://abt.tj/news-backend/${image.src}`} alt={image.alt[i18n.language]} />
                </div>
              ))}
            </div>
          )}
        </article>
      </Container>
    </NewsStyled>
  );
}

export default News;